module.exports = __webpack_public_path__ + "img/404.0961c216.svg";